import { EventEmitter } from "@angular/core";

import each from "lodash/each";
import { Subject, Subscription } from "rxjs";

import { Constructor } from "../types/constructor";

export interface IDisposable {
    dispose(): void;
}

export function DisposeMixin<TBaseClass extends Constructor<any>>(
    BaseClass: TBaseClass
): TBaseClass & Constructor<IDisposable> {

    class DisposableExtension extends BaseClass implements IDisposable {
        public dispose(): void {
            const properties = Object.getOwnPropertyDescriptors(this);

            each(properties, (property: PropertyDescriptor, key: string) => {
                const value = this[key];

                if (value instanceof Subscription && !value.closed) {
                    value.unsubscribe();
                }

                if (value instanceof EventEmitter) {
                    return;
                }

                if (value instanceof Subject && !value.isStopped) {
                    value.complete();
                }
            });
        }
    }

    return DisposableExtension;
}

// tslint:disable-next-line:max-classes-per-file
export class EmptyClassInstance {
}
